import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initSecurityScanner(): void {
    const line = document.querySelector('.code-scanner__line');
    if (!line) return;

    // The line animation is already in CSS, but let's sync some text
    const codes = document.querySelectorAll('.code-scanner pre code');
    if (codes.length === 0) return;

    gsap.from(codes, {
        opacity: 0,
        y: 10,
        stagger: 0.5,
        duration: 0.5,
        scrollTrigger: {
            trigger: '.code-scanner',
            start: 'top 70%'
        }
    });
}

export function initSecurityShield(): void {
    const rings = document.querySelectorAll('.shield-ring');
    if (rings.length === 0) return;

    // Parallax or interaction if needed, otherwise CSS handles pulse
}
